import cn from "classnames";
import styles from "./LeftSideItem.module.scss";
import React, {useRef } from "react";
import { useSelector } from "react-redux";

const LeftSideItemWrapper = ({children,  item}) => {
    const elRef = useRef()
    const {user} = useSelector(state => state);

    const isHidden = item.display === "none" && (!user?.state || user.state === "Confirmed");

    return(
        <li
            ref={elRef}
            className={cn("row align-items-center rounded-circle", styles["navigation-item"], item.content === "border" ?  styles["navigation-item_border"] : "")}
            style={isHidden ? { display: "none" } : {}}
            tabIndex={-1}
        >
            {item.line && <hr className={styles["navigation-item__line"]} />}
            {children}
        </li>
    )
}

export default LeftSideItemWrapper;
